import styled, { css } from "styled-components";
import { designTokens } from '../ui/foundation/DesignTokens';

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 16px 12px 16px;
`;

export const SearchForm = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 16px;
  width: 100%;
  border: none;
  height: 44px;
  border-radius: ${designTokens.radius.xl};
  background-color: ${designTokens.colors.gray[100]};
  transition: all 0.2s ease;

  &:focus-within {
    background-color: white;
    box-shadow: 0 0 0 2px ${designTokens.colors.primary[200]};
  }

  ${(props) =>
    props.templateSelection &&
    css`
      padding-left: 0;
    `}
`;

export const SearchInput = styled.input`
  font-family: ${designTokens.fonts.body};
  font-size: 0.9rem;
  background: none;
  border: none;
  margin-left: 12px;
  font-weight: 400;
  flex-grow: 1;
  color: ${designTokens.colors.gray[900]};
  opacity: 1;

  &::placeholder {
    color: ${designTokens.colors.gray[400]};
    opacity: 1;
    font-weight: 400;
  }

  ${(props) =>
    props.templateSelection &&
    css`
      margin-left: 0.75rem;
      font-family: ${designTokens.fonts.heading};
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 150%;
      color: ${designTokens.colors.gray[500]};
    `}

  &:focus {
    opacity: 1;
    outline: none;
  }
`;

export const SearchIconContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${designTokens.colors.gray[400]};
`;

export const LabelNewAudience = styled.label`
  font-family: ${designTokens.fonts.heading};
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: -0.32px;
  margin-left: 24px;
  margin-bottom: 12px;
  color: ${designTokens.colors.gray[500]};
`;
